module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('transition-group', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    key: "duplicate",
    staticClass: "modal-mask",
    attrs: {
      "id": "form_plano"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-wrapper _modalWrapper_"
  }, [_c('div', {
    staticClass: "modal-container flexContainer"
  }, [_c('div', {
    staticClass: "modalBody",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "_container_ rel"
  }, [_c('img', {
    staticClass: "cross fright abs pointer",
    attrs: {
      "src": require("../../assets/croix.png"),
      "width": "20",
      "height": "20",
      "alt": ""
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), (_vm.openPlanoId !== null) ? _c('div', {
    staticClass: "_result flexContainer full fd-c ai-c"
  }, [_c('div', {
    staticClass: "full ai-c ff-medium txtCenter mt25"
  }, [_c('span', {
    staticClass: "titles"
  }, [_vm._v(_vm._s(_vm.$t("plano.your_plano")))]), _vm._v(" "), _c('span', {
    staticClass: "bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.currentPlanoName))])]), _vm._v(" "), _c('div', {
    staticClass: "full ai-c ff-medium txtCenter mt10"
  }, [_c('span', {
    staticClass: "titles"
  }, [_vm._v(_vm._s(_vm.$t("plano.duplicate_message")))]), _vm._v(" "), _c('span', {
    staticClass: "bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.newPlano.name))])]), _vm._v(" "), _c('div', {
    staticClass: "full ai-c ff-medium txtCenter mt25"
  }, [_c('button', {
    staticClass: "btn rel iBlock pointer clear mobileNot txtCenter ",
    on: {
      "click": function($event) {
        _vm.openPlano(_vm.newPlano);
      }
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t("plano.open_plano")) + "\n                                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "note full txtCenter"
  }, [_vm._v(_vm._s(_vm.$t("plano.note_duplicate_plano")))])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "fd-r fw-w m-jc-sb"
  }, [_c('div', {
    staticClass: "flexContainer fd-c ai-c jc-fs"
  }, [_c('p', {
    staticClass: "ff-light flexContainer fd-r jc-c"
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t("plano.duplicate_plano")) + "   "), _c('strong', [_vm._v(_vm._s(_vm.currentPlanoName))])]), _vm._v(" "), _c('div', {
    staticClass: "flexContainer fd-c"
  }, [_c('label', {
    staticClass: "full ff-medium fleft labelName"
  }, [_vm._v(_vm._s(_vm.$t("plano.enter_new_name")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlano.name),
      expression: "newPlano.name"
    }],
    staticClass: "full planoName mt10",
    attrs: {
      "name": "",
      "placeholder": _vm.$t('plano.name_placeholder')
    },
    domProps: {
      "value": (_vm.newPlano.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlano.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.sameName) ? _c('p', {
    staticClass: "danger"
  }, [_vm._v(_vm._s(_vm.$t("duplicatePlano.saveName")))]) : _vm._e(), _vm._v(" "), (_vm.nullName) ? _c('p', {
    staticClass: "danger"
  }, [_vm._v(_vm._s(_vm.$t("duplicatePlano.enterName")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('p', {
    staticClass: "ff-light flexContainer fd-r jc-c"
  }, [_vm._v(_vm._s(_vm.$t("plano.select_campaign")))]), _vm._v(" "), (_vm.nullCampaign) ? _c('p', {
    staticClass: "danger"
  }, [_vm._v(_vm._s(_vm.$t("duplicatePlano.selectCampign")))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flexContainer logoContainer jc-c fd-r fw-w m-jc-sb"
  }, _vm._l((_vm.getCampaigns), function(campaign) {
    return _c('div', {
      key: campaign.id,
      staticClass: "brandWrap jc-c pointer"
    }, [_c('p', {
      staticClass: "brandLogo txtCenter uppercase",
      class: [
        _vm.selectedPlanoCampaign === campaign.id ? '_selectedCampaign' : '_notselectedCampaign',
        ''
      ],
      on: {
        "click": function($event) {
          _vm.updateCampaign(campaign.id, campaign);
        }
      }
    }, [_vm._v("\n                                                    " + _vm._s(campaign.name) + "\n                                                ")])])
  })), _vm._v(" "), _c('p', {
    staticClass: "ff-light flexContainer fd-r jc-c"
  }, [_vm._v(_vm._s(_vm.$t("plano.select_zone")))]), _vm._v(" "), (_vm.nullZone) ? _c('p', {
    staticClass: "danger"
  }, [_vm._v(_vm._s(_vm.$t("duplicatePlano.selectZone")))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flexContainer logoContainer jc-c fd-r fw-w m-jc-sb"
  }, _vm._l((_vm.getZones), function(zone) {
    return _c('div', {
      key: zone.id,
      staticClass: " brandWrap jc-c pointer"
    }, [_c('p', {
      staticClass: "brandLogo txtCenter uppercase",
      class: [_vm.selectedPlanoZone === zone.id ? '_selectedZone' : '_notselectedZone', ''],
      on: {
        "click": function($event) {
          _vm.updateZone(zone.id);
        }
      }
    }, [_vm._v("\n                                                    " + _vm._s(zone.name) + "\n                                                ")])])
  })), _vm._v(" "), _c('p', {
    staticClass: "ff-light flexContainer fd-r jc-c"
  }, [_c('button', {
    staticClass: "btn_validate pointer",
    on: {
      "click": _vm.duplicatePlano
    }
  }, [_vm._v(_vm._s(_vm.$t("plano.btn_validate")))])])])])])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b456311a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planos/duplicate.vue
// module id = 3348
// module chunks = 0